// --- Reusable columns for data capturing tables ---
export const unitInputColumn = {
    label: 'Unit',
    field: 'unit',
    type: 'select',
    selectLabel: 'Select Unit',
    // options can be defined in the specific category columns
}

export const valueInputColumn = {
    label: 'Value',
    field: 'quantity',
    type: 'text',
    placeholder: 'Value',
}

export const fileUploadColumn = {
    label: 'Source Document (Optional)',
    field: 'file',
    type: 'file'
}

export const totalsColumn = {
    kilograms: [
        { label: 'Month', field: 'month' },
        { label: 'Total Kilograms', field: 'total' }
    ],
    kilolitres: [
        { label: 'Month', field: 'month' },
        { label: 'Total Kilolitres', field: 'total' }
    ],
    kilowatts: [
        { label: 'Month', field: 'month' },
        { label: 'Total kWh', field: 'total' }
    ],
}

export const grandTotalFields = {
    kilograms: [
        { label: 'Grand Total', field: 'month' },
        { label: 'Grand Total Kilograms', field: 'grand_total' }
    ],
    kilolitres: [
        { label: 'Grand Total', field: 'month' },
        { label: 'Grand Total Kilolitres', field: 'grand_total' }
    ],
    kilowatts: [
        { label: 'Grand Total', field: 'month' },
        { label: 'Grand Total kWh', field: 'grand_total' }
    ],
    unspecified: [
        { label: 'Grand Total', field: 'month' },
        { label: 'Grand Total Value', field: 'grand_total' },
    ]
}

export const interDcDistributionOptions = [
    { id: 6, value: "HGV (all diesel), Rigid (>3.5 - 7.5 tonnes)" },
    { id: 7, value: "HGV (all diesel), Rigid (>7.5 tonnes-17 tonnes)" },
    { id: 8, value: "HGV (all diesel), Rigid (>17 tonnes)" },
    { id: 9, value: "HGV (all diesel), Articulated (>3.5 - 33t)" },
    { id: 10, value: "HGV (all diesel), Articulated (>33t)" },
]

export const farmDcDistributionOptions = [
    { id: 0, value: "Vans (petrol), Class I (up to 1.305 tonnes)" },
    { id: 1, value: "Vans (petrol), Class II (1.305 to 1.74 tonnes)" },
    { id: 2, value: "Vans (petrol), Class III (1.74 to 3.5 tonnes)" },
    { id: 3, value: "Vans (diesel), Class I (up to 1.305 tonnes)" },
    { id: 4, value: "Vans (diesel), Class II (1.305 to 1.74 tonnes)" },
    { id: 5, value: "Vans (diesel), Class III (1.74 to 3.5 tonnes)" },
    { id: 6, value: "HGV (all diesel), Rigid (>3.5 - 7.5 tonnes)" },
    { id: 7, value: "HGV (all diesel), Rigid (>7.5 tonnes-17 tonnes)" },
    { id: 8, value: "HGV (all diesel), Rigid (>17 tonnes)" },
    { id: 9, value: "HGV (all diesel), Articulated (>3.5 - 33t)" },
    { id: 10, value: "HGV (all diesel), Articulated (>33t)" },
]

export const shippingDistributionOptions = [
    { id: 16, value: "Freight flights, Domestic" },
    { id: 17, value: "Freight flights, International" },
    { id: 18, value: "Rail, Freight train" },
    { id: 19, value: "Cargo ship, Bulk carrier" },
    { id: 20, value: "Cargo ship, General cargo" },
    { id: 21, value: "Cargo ship, Container ship" }
]

export const regionalDistributionOptions = [
    { id: 0, value: "Vans (petrol), Class I (up to 1.305 tonnes)" },
    { id: 1, value: "Vans (petrol), Class II (1.305 to 1.74 tonnes)" },
    { id: 2, value: "Vans (petrol), Class III (1.74 to 3.5 tonnes)" },
    { id: 3, value: "Vans (diesel), Class I (up to 1.305 tonnes)" },
    { id: 4, value: "Vans (diesel), Class II (1.305 to 1.74 tonnes)" },
    { id: 5, value: "Vans (diesel), Class III (1.74 to 3.5 tonnes)" },
]